import { Box, alpha } from '@mui/material'
import { C1BorderRadius } from 'c1ui/theme/C1BorderRadius'
import { FC, PropsWithChildren } from 'react'

type C1ScrollBoxProps = {
    maxHeight?: string
} & PropsWithChildren

/**
 * A scrolling container that will always show it's associated scrollbar, so that you
 * the user has more affordance to know that content is being cut off. Has a configurable
 * `maxHeight`, defaulting to 380px.
 */
export const C1ScrollBox: FC<C1ScrollBoxProps> = ({ children, maxHeight = '380px' }) => {
    return (
        <Box sx={{
            py: 2,
            overflowY: 'auto',
            maxHeight,

            '&::-webkit-scrollbar': {
                width: '8px',
            },
            '&::-webkit-scrollbar-track': {
                background: (t) => alpha(t.palette.border.subtle, 0.1),
                borderRadius: C1BorderRadius.regular,
            },
            '&::-webkit-scrollbar-thumb': {
                backgroundColor: (t) => alpha(t.palette.border.subtle, 0.5),
                borderRadius: C1BorderRadius.regular,
                border: '2px solid',
                borderColor: (t) => alpha(t.palette.border.subtle, 0.1),
            },
        }}
        >
            {children}
        </Box>
    )
}
